import { useState } from "react";
import { MailWarning, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const EmailBanner = () => {
  const { user, refreshUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      if (data.already_verified) { await refreshUser(); return; }
      toast.success(`Confirmation email sent to ${user.email}`);
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="mb-5 flex flex-col gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 sm:flex-row sm:items-center sm:justify-between dark:border-amber-500/30 dark:bg-amber-500/10" data-testid="email-verify-banner">
      <div className="flex gap-3">
        <MailWarning className="mt-0.5 h-5 w-5 shrink-0 text-amber-700 dark:text-amber-300" />
        <div>
          <p className="text-sm font-semibold text-amber-900 dark:text-amber-100">Confirm your email</p>
          <p className="mt-0.5 text-sm text-amber-800 dark:text-amber-200/80">
            We sent a link to <span className="font-medium">{user.email}</span>. Your quote link and 14-day free trial start after you confirm.
          </p>
        </div>
      </div>
      <button type="button" onClick={resend} disabled={busy} data-testid="email-verify-resend-button"
        className="flex h-10 shrink-0 items-center justify-center gap-2 rounded-lg bg-amber-900 px-4 text-sm font-semibold text-white disabled:opacity-50 dark:bg-amber-200 dark:text-amber-950">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Resend email
      </button>
    </div>
  );
};
